import { compose, withHandlers } from 'recompose'
import { connect } from 'react-redux'
import { googleAnalyticProductRemoveFromCart } from 'actions/googleAnalytic'
import { removeFromCartAction } from '../actions'
import { getGTMKitData } from 'helpers/googleAnalytic'
import Kit from './Kit'

export default compose(
  connect(null, { removeKitFromCartAction: removeFromCartAction, googleAnalyticProductRemoveFromCart }),
  withHandlers({
    removeKitFromCartActionHandler: ({
      removeKitFromCartAction,
      googleAnalyticProductRemoveFromCart,
      kit: {
        commerceItemId
      },
      kit
    }) => () => {
      removeKitFromCartAction(commerceItemId)
      googleAnalyticProductRemoveFromCart({ data: getGTMKitData(kit) })
    }
  })
)(Kit)
